import { useAppSelector } from '@redux/hooks';
import {
	MIN_REVIEW_PILLS,
	WAVE_1_CATEGORY_CODES,
} from '../redux/vendor/constants';

export const useIsReviewPillsEligible = () => {
	return useAppSelector((state) => {
		const categoryCode = state.vendor.vendor?.categoryCode;
		const isWave1Category =
			categoryCode != null && WAVE_1_CATEGORY_CODES.includes(categoryCode);
		const pillsCount = state.vendor.vendorRaw?.reviewsPills?.length ?? 0;

		return isWave1Category && pillsCount >= MIN_REVIEW_PILLS;
	});
};
